import { z } from 'zod';
import { ReportType, reportGroups } from '../report-catalog';

const availableReportTypes = reportGroups.reduce<ReportType[]>((reportTypes, group) => {
	for (const report of group.reports) {
		if (report.isAvailable) {
			reportTypes.push(report.key);
		}
	}

	return reportTypes;
}, []);

export const reportTypeSchema = z.enum(availableReportTypes as [ReportType, ...ReportType[]]);
